import "./js/app.js";
import "./js/app.init.dark.js";
import "./js/sidebarmenu.js";
import "./bootstrap_custom.js";
import "../common/notice/notice"
import "../common/select2/select2"
import "../common/imagecoo/imagecoo"
import "../common/picker/picker"
import "../common/sweetalert/sweetalert"
import "../common/validation/validation"
import "../common/picker/colorpicker"
import "../common/quill-editor/quill-editor"
import "../common/charts/charts"
import "../common/sortable"
import "./js/custom.js";
import "@nathanvda/cocoon"

import "@fortawesome/fontawesome-free/css/all"
import("../../styles/admin/admin.scss");

$(function() {
    $("form[novalidate='novalidate']").find("input,select,textarea").not("[type=submit]").jqBootstrapValidation();

    $("body").on("click", ".dropdown-toggle-title" ,function(e){
        e.preventDefault();

        const getData = $(".article-status-input").val();
        if(getData == 0){
        const message = "請問您確定要<br />現在（<span class='pub-date'>2021/6/23 上午10:00</span>） 發布嗎？";
        const text = "";

        Swal.fire({
            title:             message || 'Are you sure?',
            text:              text || '',
            icon: 'info',
            showCancelButton: true,
            confirmButtonText: '發布',
            cancelButtonText: '取消',
            footer: '<input type="hidden" class="datetimepicker"><a href="" class="pub-date">排定公開時間</a>',
            customClass: {
            title: 'swal2-small-title'
            }
        }) // end swal
        }
    });

    $(".article-status").on("click", ".dropdown-item" ,function(e){
        e.preventDefault();

        const getData = $(this).data("status");
        const getContent = $(this).html();
        $(".article-status-input").val(getData);
        $(".dropdown-toggle-title").html(getContent);
    })

    $('.row1').on('change','input[type="file"]', function(e) {
        const size = e.target.files[0].size / 1024 / 1024;
        if(size > (10 / 1.3) ){
            $(this).val("");
            $(this).after('<div class="help-block text-danger"><ul role="alert"><li>圖片 size 編修後會超過 10MB</li></ul></div>')
        }else{
            $(this).parents(".form-group").find(".help-block").remove()
        }
    })
    $('input[type="file"]').on('change', function(e) {
        const size = e.target.files[0].size / 1024 / 1024;
        if(size > (10 / 1.3) ){
            $(this).val("");
            $(this).after('<div class="help-block text-danger"><ul role="alert"><li>圖片 size 編修後會超過 10MB</li></ul></div>')
        }else{
            $(this).parents(".form-group").find(".help-block").remove()
        }  
    })
});
  
  